import { makeStyles, type Theme } from '@material-ui/core/styles';

// @ts-expect-error - CustomLinearProgress doesn't have TypeScript definitions
import { CUSTOM_BUTTON_SIZE } from 'src/components/CustomButton';
import { COLORS } from 'src/data/ui';

interface StyleProps {
  size: string;
}

export const useStyles = makeStyles<Theme, StyleProps>(
  (theme) => ({
    root: {
      position: 'relative',
      minWidth: 60,
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'center',
    },
    linearProgress: {
      flex: 1,
      height: ({ size }) => calculateHeight(size),
      backgroundColor: COLORS.gray.gray90,
      borderRadius: theme.shape.borderRadiusSmall,
    },
    bar: {
      backgroundColor: COLORS.gray.gray70,
    },
    text: {
      position: 'absolute',
      color: COLORS.gray.gray50,
    },
  }),
  { name: 'ButtonLikeProgressBar' }
);

const calculateHeight = (size: string): number => {
  switch (size) {
    case CUSTOM_BUTTON_SIZE.large:
      return 48;
    case CUSTOM_BUTTON_SIZE.small:
      return 32;
    case CUSTOM_BUTTON_SIZE.smaller:
      return 26;

    case CUSTOM_BUTTON_SIZE.medium:
    default:
      return 40;
  }
};
